import React from 'react';
import { Icon } from '@iconify/react';

const OCCASIONS = [
  { label: '기념일', icon: 'solar:gift-bold' },
  { label: '생일 축하', icon: 'solar:cake-bold' },
  { label: '새해 복 많이', icon: 'solar:stars-bold' },
];

export default function PhotoOccasionSection({ selectedOccasion, onSelect }) {
  return (
    <div className="photo-section-card">
      <div className="photo-section-header">
        <h3 className="photo-section-title">기념일 선택</h3>
        <div className="photo-section-icon photo-icon-orange">
          <Icon icon="solar:calendar-bold" width={20} height={20} />
        </div>
      </div>
      <div className="photo-option-grid">
        {OCCASIONS.map(({ label, icon }) => (
          <button
            key={label}
            className={`photo-option-btn ${selectedOccasion === label ? 'active' : ''}`}
            onClick={() => onSelect(label)}
          >
            <Icon icon={icon} width={24} height={24} className="option-icon" />
            <span>{label}</span>
            {selectedOccasion === label && (
              <div className="checkmark">
                <Icon icon="solar:check-circle-bold" width={16} height={16} />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}


